import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  /** Await a blob response and save it to disk using the filename from its
   * Content-Disposition header, falling back if the header is missing. */
  async download(source: Observable<HttpResponse<Blob>>, fallbackFilename = 'download'): Promise<void> {
    const response = await firstValueFrom(source);
    const blob = response.body;
    if (!blob) {
      throw new Error('Download response had no body.');
    }
    this.triggerDownload(blob, this.filenameFromResponse(response) ?? fallbackFilename);
  }

  private filenameFromResponse(response: HttpResponse<Blob>): string | null {
    const disposition = response.headers.get('Content-Disposition') ?? '';
    const match = /filename="?([^";]+)"?/.exec(disposition);
    return match ? match[1] : null;
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }
}
